// Global Types
import type {
  $WithRouter,
} from '@vroskus/library-navigation';

// Global Enums
import {
  webPages,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  scrollTop,
} from '@vroskus/library-helpers/dist/browser';

// Components
import Page from '../../layout/Page';
import Loader from '../../layout/Loader';
import AuthSection from '../../sections/ProfilePageSections/AuthSection';
import RegattaNotificationsSection from '../../sections/ProfilePageSections/RegattaNotificationsSection';
import RegattaEntriesSection from '../../sections/ProfilePageSections/RegattaEntriesSection';
// import AdvertisementsSection from '../../sections/ProfilePageSections/AdvertisementsSection';
import SessionSection from '../../sections/ProfilePageSections/SessionSection';

// Types
import type {
  $ReducerState,
} from '../../../redux';
import type {
  $RedirectAction,
} from '../../../redux/modules/main/actions';

export type $OwnProps = $WithRouter;

export type $StateProps = {
  auth: $ReducerState<'auth'>;
  main: $ReducerState<'main'>;
};

export type $DispatchProps = {
  redirect: $RedirectAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  initialised: boolean;
};

class ProfilePageView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      initialised: false,
    };
  }

  componentDidMount(): void {
    this.init();
  }

  async init(): Promise<void> {
    const {
      location,
      main,
      redirect,
    } = this.props;

    const {
      RegionId,
    } = main;

    try {
      scrollTop();

      if (RegionId === null) {
        redirect({
          pathname: '/regions',
          state: {
            from: location,
          },
        });
      }

      this.setState({
        initialised: true,
      });
    } catch (err) {
      const error = err as Error;

      ErrorLog.exception(error);
    }
  }

  render() {
    const {
      auth,
    } = this.props;
    const {
      initialised,
    } = this.state;

    return (
      <Page
        id={webPages.profilePage}
        tags={{
          title: 'My data',
        }}
      >
        <Loader loading={!initialised}>
          {auth.user === null ? (
            <AuthSection />
          ) : (
            <>
              <RegattaEntriesSection />
              <RegattaNotificationsSection />
              {
              /* <AdvertisementsSection /> */
            }
              <SessionSection />
            </>
          )}
        </Loader>
      </Page>
    );
  }
}

export default ProfilePageView;
